export default __webpack_public_path__ + "52afcab4940a2540b186b3daf95e8596.png";